import { firstValueFrom } from 'rxjs';
import { Component, Injector, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { AllDashboardServiceProxy, TimesheetAndApprovalStatusEnum, TimeSheetDto } from '../../../../../shared/service-proxies/service-proxies';
import { TimesheetService } from '../../../time-sheet-new/services/timesheet.service';
import { LazyLoadEvent } from 'primeng/api';
import { AppComponentBase } from '../../../../../shared/common/app-component-base';
import { Paginator } from 'primeng/paginator';
import { TimesheetUtilityService } from '../../../time-sheet-new/services/timesheet-utility.service';
import { Router } from '@angular/router';
import { MonitoringService } from '@app/shared/common/telemetry-implementation/MonitoringService ';
import { DateTime } from 'luxon';
import { AppConsts } from '@shared/AppConsts';
import { UsersDateFormatService } from '@shared/common/dateTimeFormat/date-format.service';
import { AppRoutes } from '@app/shared/routes/app-routes';
@Component({
    standalone: false,
    selector: 'dashboard-timesheet-request',
    templateUrl: './dashboard-timesheet-request.component.html',
    styleUrls: ['./dashboard-timesheet-request.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardTimesheetRequestComponent extends AppComponentBase implements OnInit {
    timesheets: TimeSheetDto[];
    selectedTimesheets: TimeSheetDto[];
    visible: boolean = false;
    @ViewChild("paginator", { static: true })
    paginator: Paginator;
    isMyTimesheet: boolean = false;
    isLoading: boolean = true;
    // Filters
    projectIds: number[];
    userFilterIds: number[];
    timesheetStatusFilter: TimesheetAndApprovalStatusEnum;
    dateRangeFilter: Date[];
    isSummary: boolean = false;
    newestOnTopSort: boolean = false;
    dateTime = new Date();
    dateId: number;
    dateFormat = 'dd/MM/yyyy';
    constructor(private _monitorService: MonitoringService, public _ts: TimesheetService, injector: Injector, public _tus: TimesheetUtilityService, private router: Router, private _allDashboardService: AllDashboardServiceProxy, private _usersDateFormatService: UsersDateFormatService) { super(injector); }
    ngOnInit(): void {
        this.loadTimesheets();
        this.getDateFormat();
    }
    async loadTimesheets(event?: LazyLoadEvent) {
        try {
            this._monitorService.logTrace("UI-loadTimesheets", { "loadTimesheets ": "getTeamTimesheets: " + this + this.dateTime });
            this.primengTableHelper.records = undefined;
            this.selectedTimesheets = undefined;
            // Prepare date range filter
            const startDate = this.dateRangeFilter && this.dateRangeFilter[0] ? DateTime.fromJSDate(this.dateRangeFilter[0]) : undefined;
            const endDate = this.dateRangeFilter && this.dateRangeFilter[1] ? DateTime.fromJSDate(this.dateRangeFilter[1]) : undefined;
            // Fetch timesheet details
            let pagedTimesheets = await firstValueFrom(this._allDashboardService.getTeamTimesheetDetailsDashbord(undefined, this.projectIds, startDate, endDate, 0, false, true, this.timesheetStatusFilter, this.isSummary, undefined, 5, 0, undefined));
            // Update table helper with new data
            this.primengTableHelper.totalRecordsCount = pagedTimesheets.totalCount;
            this.primengTableHelper.records = pagedTimesheets.items[0].timesheetApprovalDetails;
            this.visible = pagedTimesheets.totalCount > 0;
            this.isLoading = false;
            this.markForCheck();
        }
        catch (ex: any) {
            this.isLoading = false;
            this.markForCheck();
            this._monitorService.logException(ex, 2);
        }
    }
    viewall() {
        this.router.navigate([AppRoutes.timesheet], { queryParams: { activeTab: 3 } });
    }
    getHoursFromTimespan(timespan: string) {
        let hours = parseInt(timespan?.split(":")[0]);
        let min = parseInt(timespan?.split(":")[1]);
        return `${hours < 10 ? "0" + hours : hours}:${min < 10 ? "0" + min : min} h`;
    }
    getDateFormat() {
        if (AppConsts.dateFormatId !== undefined) {
            this.dateId = AppConsts.dateFormatId;
            this.dateFormat = this._usersDateFormatService.findUsersDateFormat(this.dateId);
        }
    }
}
